import * as propertyTypes from "../property_types.js"

export class UIPanelbarDetails extends propertyTypes.AppBaseComponentProps {

    private urlMetadata = new propertyTypes.TextProperty("url", "Url");
    public url: string;

    private templateMetadata = new propertyTypes.TextProperty("template", "Template");
    public template: string;

    private moduleNameMetadata = new propertyTypes.TextProperty("moduleName", "Module name");
    public moduleName: string;

    private appNameMetadata = new propertyTypes.TextProperty("appName", "App name");
    public appName: string;

    private maxSelectedItemsMetadata = new propertyTypes.TextProperty("maxSelectedItems", "Max selected items");
    public maxSelectedItems: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.urlMetadata, this.moduleNameMetadata, this.appNameMetadata, this.templateMetadata, this.maxSelectedItemsMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}